import { Action } from '@ngrx/store';

export enum LeavePageActionTypes {
  UpdateFormDirtyStatus = '[FormStatus] Update Form Dirty Status',
  LeavePageConfirmation = '[LeaveEditing] Leave Page Confirmation',
  SelectionChanged = '[LeaveEditing] Selection Changed'
}

export class UpdateFormDirtyStatus implements Action {
  readonly type = LeavePageActionTypes.UpdateFormDirtyStatus;

  constructor(public payload: { formDirty: boolean }) {
  }
}

/**
 * Action that should be dispatched in case when we are leaving form editing, but there is not navigation.
 * As payload can be provided list of actions that should be dispatched in case when we confirm leaving of the edit mode.
 */
export class LeavePageConfirmation implements Action {
  readonly type = LeavePageActionTypes.LeavePageConfirmation;

  constructor(public payload: { actions: Action[] }) {
  }
}

/**
 * Action that should be dispatched in case when we are leaving form editing with change of the selected item.
 * As payload can be provided list of actions that should be dispatched in case when we confirm changing of selection.
 */
export class SelectionChanged implements Action {
  readonly type = LeavePageActionTypes.SelectionChanged;

  constructor(public payload: { actions: Action[] }) {
  }
}

export type LeavePageActions =
  | LeavePageConfirmation
  | UpdateFormDirtyStatus
  | SelectionChanged;


export function setFormDirtyStatus() {
  return new UpdateFormDirtyStatus({formDirty: true});
}

export function resetFormDirtyStatus() {
  return new UpdateFormDirtyStatus({formDirty: false});
}

export function leavePageConfirmation(actions: Action[] = []) {
  return new LeavePageConfirmation({actions});
}
